import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {SharedDataService} from "../../../services/shared-data.service";
import {FormControl, FormGroup} from "@angular/forms";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";
import {ListItem} from "../../../objects/listItem";

@Component({
  selector: 'app-trainer-setup-popup',
  templateUrl: './trainer-setup-popup.component.html',
  styleUrls: ['./trainer-setup-popup.component.css']
})
export class TrainerSetupPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() success = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  public componentForm: FormGroup = new FormGroup({});
  packages: object[];
  state: string = 'edit';
  errMsg: string = '';
  profilePayloadParsed: object;
  constructor(public sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.profilePayloadParsed = JSON.parse(this.payload['item']['itemFullData']['payload']);
    this.profilePayloadParsed = this.profilePayloadParsed ? this.profilePayloadParsed : {};
    if(!this.profilePayloadParsed['packages']) this.profilePayloadParsed['packages'] = [];
    this.state = 'loading';
    this.application.apiService.getPackageDetails(environment['gid'],environment['g_hash'],true)
      .subscribe (
        data => {
          //this.services = JSON.parse(data['package_services']);
          this.packages = data['packages'];
          this.addFormControls()
          this.state = 'edit';
        },
        error => {
          this.state = 'error';
          console.log('error',error);
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
          }
        }
      )
  }

  public addFormControls(): void {
    this.packages.forEach((packageItem, idx) => {
      const packageEnabledControl = new FormControl();
      this.componentForm.addControl('packageEnabled_'+idx, packageEnabledControl);

      const packagePriceControl = new FormControl();
      this.componentForm.addControl('packagePrice_'+idx, packagePriceControl);
      let packagePriceValue = packageItem['price'];
      const packageGuestPriceControl = new FormControl();
      this.componentForm.addControl('packageGuestPrice_'+idx, packageGuestPriceControl);
      let packageGuestPriceValue = packageItem['guest_price'] ? packageItem['guest_price'] : packageItem['price'];
      const packageDiscountPriceControl = new FormControl();
      this.componentForm.addControl('packageDiscountPrice_'+idx, packageDiscountPriceControl);
      let packageDiscountPriceValue = packageItem['discount_price'] ? packageItem['discount_price'] : packageItem['price'];

      this.profilePayloadParsed['packages'].forEach(profilePackage => {
        if(profilePackage['id'] != packageItem['id']) return;
        packagePriceValue = profilePackage['price'];
        packageGuestPriceValue = profilePackage['guest_price'] ? profilePackage['guest_price'] : profilePackage['price'];
        packageDiscountPriceValue = profilePackage['discount_price'] ? profilePackage['discount_price'] : profilePackage['price'];
        if(!profilePackage['disabled']) {
          packageEnabledControl.setValue(true)
        }
      })
      packagePriceControl.setValue(packagePriceValue);
      packageGuestPriceControl.setValue(packageGuestPriceValue);
      packageDiscountPriceControl.setValue(packageDiscountPriceValue);
    })
  }

  public handleSubmit(): void {
    this.packages.forEach((packageItem, idx) => {
      let packageFound = false;
      this.profilePayloadParsed['packages'].forEach(profilePackage => {
        if(profilePackage['id'] != packageItem['id']) return;
        packageFound = true;
        profilePackage['disabled'] = !this.componentForm.get('packageEnabled_'+idx).value
        profilePackage['price'] = parseInt(this.componentForm.get('packagePrice_'+idx).value);
        profilePackage['guest_price'] = parseInt(this.componentForm.get('packageGuestPrice_'+idx).value);
        profilePackage['discount_price'] = parseInt(this.componentForm.get('packageDiscountPrice_'+idx).value);
      })
      if(!packageFound) {
        let profilePackage = {}
        profilePackage['disabled'] = !this.componentForm.get('packageEnabled_'+idx).value;
        profilePackage['price'] = parseInt(this.componentForm.get('packagePrice_'+idx).value);
        profilePackage['guest_price'] = parseInt(this.componentForm.get('packageGuestPrice_'+idx).value);
        profilePackage['discount_price'] = parseInt(this.componentForm.get('packageDiscountPrice_'+idx).value);
        profilePackage['id'] = packageItem['id'];
        this.profilePayloadParsed['packages'].push(profilePackage)
      }
    })

    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['target_profile_id'] = this.payload['item']['itemFullData']['id'];
    params['payload'] = {};
    params['payload']['packages'] = {};
    params['payload']['packages'] = this.profilePayloadParsed['packages'];

    this.state = 'loading';
    this.application.apiService.updateProfilePayload(params).subscribe(
      res => {
        this.state = 'edit';
        //this.application.getCurrentUser();
        this.payload['newProfilePayload'] = JSON.stringify(this.profilePayloadParsed);
        this.success.emit()
      },
      error => {
        this.state = 'error';
        const { exception } = error;
        const errMsg = error['errMsg'] ? error['errMsg'] : (
          (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
        );
      }
    );
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

}
